import React from 'react';

const arrowHeadLeftIcon = () => (
  <svg viewBox="0 0 100 100">
    <polygon points="90,0 90,100 25,50"></polygon>
  </svg>
)

export default arrowHeadLeftIcon;